import React from 'react'
import styled from 'styled-components'

import BgImage from '../../assets/images/bg3.png'

const Wrapper = styled.section`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: ${({ autoHeight }) => autoHeight ? '500px' : '140vh'};
  background: #171717;
  background: top left no-repeat;
  background-image: url(${BgImage});
  background-size: cover;
  transition: all 0.3s ease;
`

const Container = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.sizes.maxContentWidth};
  margin: 0 auto;
  padding: 140px 30px 100px 30px;

  h2 {
    position: relative;
    margin: 0 0 25px;
    font-size: 120px;
    line-height: 0.85;

    > span {
      font-weight: ${({ theme }) => theme.font.bold};
    }
  }

  h4 {
    margin: 0 0 25px;
    font-size: 30px;
    font-weight: ${({ theme }) => theme.font.bold};
    color: ${({ theme }) => theme.colors.primary};
  }

  ${({ theme }) => theme.media.l} {
    padding: 180px 50px 100px 50px;
  }

  ${({ theme }) => theme.media.xl} {
    padding: 240px 50px 100px 50px;
  }

  ${({ theme }) => theme.media.xxl} {
    padding: 360px 50px 100px 50px;
  }
`

const OneColumn = ({ autoHeight, children }) => (
  <Wrapper autoHeight={autoHeight}>
    <Container>{children}</Container>
  </Wrapper>
)

export default OneColumn
